<div class="min-h-screen flex flex-col items-center justify-center bg-surface-ground">
  <router-outlet />
</div>
